import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ɵDecadeHeaderComponent as DecadeHeaderComponent } from "ng-zorro-antd/date-picker";

@Component({
  selector: "ui-decade-header",
  exportAs: "uiDecadeHeader",
  templateUrl: "../date-header/date-header.component.html",
  styleUrls: ["decade-header.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "ui-date-header",
  },
})
export class UiDecadeHeaderComponent extends DecadeHeaderComponent {
  /** the id of the element holding month and year buttons and used to label the table of dates/months/years/decades */
  @Input()
  public uiLabelId: string;
}
